import { createClient } from '@/shared/api';
import type {
  CreateShipmentOrderMutation,
  CreateShipmentOrderMutationVariables,
} from '@/shared/api';
import CREATE_SHIPMENT_ORDER from '../mutations/createShipmentOrder';

/**
 * Places a carrier shipment order for an RMA return. Runs CREATE_SHIPMENT_ORDER and throws createShipmentOrder.message on failure, returning the created shipmentOrder otherwise.
 *
 * @param input - Mutation input payload.
 * @returns The created shipment order.
 */
const handleCreateShipmentOrder = async (
  input: CreateShipmentOrderMutationVariables['input'],
): Promise<NonNullable<CreateShipmentOrderMutation['createShipmentOrder']>['shipmentOrder']> => {
  const client = createClient();
  const result = await client.mutate<
    CreateShipmentOrderMutation,
    CreateShipmentOrderMutationVariables
  >({
    mutation: CREATE_SHIPMENT_ORDER,
    variables: {
      input,
    },
  });
  // client.mutate's default errorPolicy throws before this line on any GraphQL error, so data is always present here.
  const { createShipmentOrder } = result.data!;
  if (!createShipmentOrder!.isSuccess) {
    throw new Error(createShipmentOrder!.message ?? undefined);
  }
  return createShipmentOrder!.shipmentOrder;
};

export default handleCreateShipmentOrder;
